import { platformApi } from '@/apis';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { log } from '@/utils';

export function useDeleteIntelligenceItem() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (code) => {
      if (code) {
        log('Delete', 'Priority Intelligence', { code });

        return platformApi.delete(`intelligence/${code}`).json();
      }
    },
    onSuccess: () =>
      queryClient.invalidateQueries({ queryKey: ['intelligence'] }),
  });
}
